// 客户档案-操作记录
<template>
  <div>
    <tablePageComp
      :columnsList="columnsList"
      :dataList="dataList"
      :orderNumConfig="{}"
      :getDataConfig="dataQueryFunc()"
      :updateDataTag="updateDataTag"
      :totalCount="total"
    ></tablePageComp>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dataList: [],
      columnsList: [
        {
          label: "操作内容",
          prop: "content",
        },
        {
          label: "时间",
          prop: "create_time",
        },
        // {
        //   label: "操作人",
        //   prop: "sender_id",
        //   formatter: (row) => this.$tools.conversionName(row),
        // },
      ],
      updateDataTag: false,
      total: 0,
    };
  },
  methods: {
    dataQueryFunc() {
      let paramObj = {
        // message_type: 9, // 客户档案操作记录
        customer_file_id: this.$store.state.customFile.baseInfoDetail
          .customer_file_id,
      };
      return {
        apiName: "apiSystemDynamic",
        paramObj,
        success: (res, callback) => {
          // console.log(res);
          if (res.data.code === 0) {
            this.dataList = res.data.data.list;
            this.total = res.data.data.count;
          }
          if (callback) callback();
        },
        failed: (err, callback) => {
          console.log(err);
          if (callback) callback();
        },
      };
    },
  },
};
</script>

<style></style>
